function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ijgvxq470a",
  colorInterpolationFilters: "auto"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.447059 0 0 0 0 0.701961 0 0 0 0 0.184314 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "1kmaj3s29b",
  d: "M20.417 8.417l-9.723 9.166c-.176.167-.353.25-.618.25s-.442-.083-.619-.25l-4.42-4.166c-.353-.334-.353-.834 0-1.167.354-.333.885-.333 1.238 0l3.8 3.583L19.18 7.25c.354-.333.884-.333 1.238 0 .353.333.353.833 0 1.167z"
}));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  filter: "url(#ijgvxq470a)",
  transform: "translate(-1021.000000, -96.000000) translate(1005.000000, 80.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.969697, 16.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "o8ywh0t56c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#1kmaj3s29b"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#o8ywh0t56c)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H25.709V24.24H0z"
}))))));
function SvgIconsFeatherCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFeatherCheck);
export default __webpack_public_path__ + "static/media/icons-feather-check.58678e15d1cbc284b2c6dc5c255138b5.svg";
export { ForwardRef as ReactComponent };